import React, { useState, useEffect, useRef } from "react";
import "dayjs/locale/zh-cn";
import { Spin } from "antdv5";
import { registerLocale } from "react-datepicker";
import zhCN from "date-fns/locale/zh-CN";
import "react-datepicker/dist/react-datepicker.css";
import DefaultLayout from "components/layout/DefaultLayout";
import useAPI from "components/customHook/useApi";
import { DailyDetail } from "../styles/DailyTotal";
import FunctionBox from "components/pages/DailyTotal/FunctionBox";
import DailyTotalTable from "components/pages/DailyTotal/DailyTotalTable";
import { IDeviceAction, IMessageSensorCode } from "../api_types";
import { notification } from "antdv5";
import {
  GETJsonDeviceActionIDList,
  GETJsonDeviceSensorCodeCount,
} from "../api";

type IMonkeyPatchedSensorCode = IMessageSensorCode & { rank: number };

registerLocale("zh", zhCN);

const DailyTotal = () => {
  const {
    handleAuth,
    preventRefreshCount,
    loading: spinLoading,
    handleEnter,
    clubList,
  } = useAPI();
  const [api, ctx] = notification.useNotification();
  const [data, setData] = useState<IMonkeyPatchedSensorCode[]>([]);
  const [loading, setLoading] = useState(false);
  const [noActionID, setNoActionID] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    new Date(),
    new Date(),
  ]);
  const [startDate, endDate] = dateRange;
  const [actionIDList, setActionIDList] = useState<{ value: string }[]>([]);
  const [hint, setHint] = useState("");
  const [searchDevice, setSearchDevice] = useState("");
  const inputRef = useRef();
  const fetchActionID = () => {
    const gid = localStorage.getItem("gid") || "";
    const token = localStorage.getItem("token") || "";
    GETJsonDeviceActionIDList(gid, token).then((res) => {
      if (res.Data !== null) {
        let result: { value: string }[] = [];
        const extractTime = (item: string) => {
          const result = item.split(" ");
          return result[0];
        };
        (res.Data as IDeviceAction[]).slice(0, 10).forEach((item) => {
          result.push({
            value:
              extractTime(item.Date.replace(/T/g, " ")) + " " + item.ActionID,
          });
        });
        setActionIDList(result);
      } else {
        let result = [{ value: "查无资料" }];
        setActionIDList(result);
      }
    });
  };
  const fetchData = async () => {
    setLoading(true);
    if (startDate !== null && endDate === null) {
      alert("结束日期不能为空");
    } else {
      let startTime = startDate
        ? Intl.DateTimeFormat("zh-CN").format(startDate).replace(/\//g, "-")
        : "";
      let endTime = endDate
        ? Intl.DateTimeFormat("zh-CN").format(endDate).replace(/\//g, "-")
        : "";
      setHint(startTime + " 至 " + endTime);
      setSearchDevice(searchValue);
      const gid = localStorage.getItem("gid") || "";
      const token = localStorage.getItem("token") || "";
      const parsedData = await GETJsonDeviceSensorCodeCount(
        gid,
        startTime,
        endTime,
        searchValue,
        token
      );
      if (parsedData.Data && parsedData.Data.length > 0) {
        const validData = await parsedData.Data.filter(
          (item: IMessageSensorCode) => item.DeviceUUID !== ""
        );
        const filterNull = await parsedData.Data.filter(
          (item: IMessageSensorCode) => item.DeviceUUID === ""
        );
        let result: IMonkeyPatchedSensorCode[] = [];
        await validData.forEach((elem: IMessageSensorCode, i: number) => {
          result.push({ ...elem, rank: (i += 1) });
        });
        if (filterNull.length > 0) {
          setNoActionID(filterNull[0].DeviceCount);
        }
        setData(result);
      } else if (parsedData.Data && parsedData.Data.length === 0) {
        setData([]);
        setNoActionID(0);
        api.info({
          message: "注意!",
          description: "查无资料",
          placement: "top",
        });
      } else {
        alert("未知错误");
      }
    }
    setLoading(false);
  };
  const searchData = useDebounce(fetchData, 100);
  const handleSearch = () => {
    preventRefreshCount(searchData, 3);
  };
  function useDebounce<T>(fn: T, delay: number) {
    const ref = useRef<{ fn: T; timer: any }>({ fn, timer: null });
    useEffect(() => {
      ref.current.fn = fn;
    }, [fn]);
    function f(...args: any[]) {
      if (ref.current.timer) {
        clearTimeout(ref.current.timer);
      }
      ref.current.timer = setTimeout(function (this: any) {
        (ref.current.fn as Function).call(this, ...args);
      }, delay);
    }
    return f;
  }
  useEffect(() => {
    setData([]);
    setHint("");
    setSearchDevice("");
    setSearchValue("");
    handleAuth();
    fetchActionID();
  }, [localStorage.getItem("gid")]);
  return (
    <>
      {ctx}
      <DefaultLayout>
        <Spin spinning={spinLoading} tip={"请等候3秒"}>
          <DailyDetail>
            <FunctionBox
              startDate={startDate}
              endDate={endDate}
              inputRef={inputRef}
              searchValue={searchValue}
              searchData={searchData}
              setDateRange={setDateRange}
              actionIDList={actionIDList}
              setSearchValue={setSearchValue}
              handleEnter={handleEnter}
              handleSearch={handleSearch}
              handleAuth={handleAuth}
              preventRefreshCount={preventRefreshCount}
              clubList={clubList}
            />
            <DailyTotalTable
              hint={hint}
              searchDevice={searchDevice}
              data={data}
              loading={loading}
              noActionID={noActionID}
            />
          </DailyDetail>
        </Spin>
      </DefaultLayout>
    </>
  );
};

export default DailyTotal;
